var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon, _polygon2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170.08 170.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #1f140f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.93,33.7h43.68v105.91h-43.68c-6.84,0-12.43-5.59-12.43-12.43V46.13c0-6.84,5.59-12.43,12.43-12.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.64,140.65h-44.71c-7.42,0-13.46-6.04-13.46-13.46V46.13c0-7.42,6.04-13.46,13.46-13.46h44.71v107.98ZM44.93,34.73c-6.28,0-11.39,5.11-11.39,11.39v81.06c0,6.28,5.11,11.39,11.39,11.39h42.64V34.73h-42.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.88,31.64h43.68v105.91h-43.68c-6.84,0-12.43-5.59-12.43-12.43V44.07c0-6.84,5.59-12.43,12.43-12.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.59,138.59h-44.71c-7.42,0-13.46-6.04-13.46-13.46V44.07c0-7.42,6.04-13.46,13.46-13.46h44.71v107.98ZM42.88,32.68c-6.28,0-11.39,5.11-11.39,11.39v81.06c0,6.28,5.11,11.39,11.39,11.39h42.64V32.68h-42.64Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.14,46.04v34.03h-39.32v-46.03h27.32c6.6,0,12,5.4,12,12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.14,81.07h-41.32v-48.03h28.32c7.17,0,13,5.83,13,13v35.03ZM101.82,79.07h37.32v-33.03c0-6.07-4.93-11-11-11h-26.32v44.03Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.3,43.21v34.03h-39.32V31.21h27.32c6.6,0,12,5.4,12,12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.3,78.24h-41.32V30.21h28.32c7.17,0,13,5.83,13,13v35.03ZM98.98,76.24h37.32v-33.03c0-6.07-4.93-11-11-11h-26.32v44.03Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.82,92.69h39.32v35.45c0,6.6-5.4,12-12,12h-27.32v-47.45Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.14,141.14h-28.32v-49.45h41.32v36.45c0,7.17-5.83,13-13,13ZM101.82,139.14h26.32c6.07,0,11-4.93,11-11v-34.45h-37.32v45.45Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.98,89.85h39.32v35.45c0,6.6-5.4,12-12,12h-27.32v-47.45Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.3,138.3h-28.32v-49.45h41.32v36.45c0,7.17-5.83,13-13,13ZM98.98,136.3h26.32c6.07,0,11-4.93,11-11v-34.45h-37.32v45.45Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.76,32.52h43.68v105.91h-43.68c-6.84,0-12.43-5.59-12.43-12.43V44.95c0-6.84,5.59-12.43,12.43-12.43Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.47,139.47h-44.71c-7.42,0-13.46-6.04-13.46-13.46V44.95c0-7.42,6.04-13.46,13.46-13.46h44.71v107.98ZM43.76,33.56c-6.28,0-11.39,5.11-11.39,11.39v81.06c0,6.28,5.11,11.39,11.39,11.39h42.64V33.56h-42.64Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.65,30.07h43.84v106.31h-43.84c-6.86,0-12.47-5.61-12.47-12.47V42.55c0-6.86,5.61-12.47,12.47-12.47Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.42,137.42h-44.71c-7.42,0-13.46-6.06-13.46-13.51V42.58c0-7.45,6.04-13.51,13.46-13.51h44.71v108.34ZM41.7,31.15c-6.28,0-11.39,5.13-11.39,11.43v81.32c0,6.3,5.11,11.43,11.39,11.43h42.64V31.15h-42.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139,44.91v34.03h-39.32v-46.03h27.32c6.6,0,12,5.4,12,12Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140,79.94h-41.32V31.91h28.32c7.17,0,13,5.83,13,13v35.03ZM100.68,77.94h37.32v-33.03c0-6.07-4.93-11-11-11h-26.32v44.03Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.17,42.07v34.03h-39.32V30.07h27.32c6.6,0,12,5.4,12,12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.17,77.1h-41.32V29.07h28.32c7.17,0,13,5.83,13,13v35.03ZM97.85,75.1h37.32v-33.03c0-6.07-4.93-11-11-11h-26.32v44.03Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.68,91.55h39.32v35.45c0,6.6-5.4,12-12,12h-27.32v-47.45Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,140h-28.32v-49.45h41.32v36.45c0,7.17-5.83,13-13,13ZM100.68,138h26.32c6.07,0,11-4.93,11-11v-34.45h-37.32v45.45Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.85,88.72h39.32v35.45c0,6.6-5.4,12-12,12h-27.32v-47.45Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M124.17,137.17h-28.32v-49.45h41.32v36.45c0,7.17-5.83,13-13,13ZM97.85,135.17h26.32c6.07,0,11-4.93,11-11v-34.45h-37.32v45.45Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "86.42 29.07 89.64 32.66 88.47 39.22 85.2 34.85 86.42 29.07"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.85 137.17 99.82 141.14 103.77 140 98.44 136.95 96.24 135.99 95.85 137.17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.85 77.1 99.82 81.07 103.18 80.07 100.68 77.43 97.85 76.24 95.85 77.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.17 87.72 141.14 91.69 139.39 94.31 137.52 93.39 136.92 91.14 137.17 87.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.14aaae57a40986d876085ff7594fb726.svg";
export { ForwardRef as ReactComponent };